import React, { useEffect, useState } from "react";
import { createIpaLesson, updateIpaLesson, fetchIpaSymbols } from "./adminIpaService";
import "../../announcement/announcement.css";
import "../../styles/content.css";

const difficultyOptions = ["BEGINNER", "INTERMEDIATE", "ADVANCED"];

const AdminIpaLessonForm = ({ lesson, onSaved, onCancel }) => {
 const isEdit = !!lesson;

 const [form, setForm] = useState({
 title: "",
 description: "",
 difficulty: "",
 sortOrder: 1,
 symbolIds: [],
 });

 const [allSymbols, setAllSymbols] = useState([]);
 const [loading, setLoading] = useState(false);

 useEffect(() => {
 loadSymbols();
 }, []);

 useEffect(() => {
 if (lesson) {
 setForm({
 title: lesson.title || "",
 description: lesson.description || "",
 difficulty: lesson.difficulty || "",
 sortOrder: lesson.sortOrder || 1,
 symbolIds: lesson.symbols?.map((s) => s.id) || [],
 });
 }
 }, [lesson]);

 const loadSymbols = async () => {
 const res = await fetchIpaSymbols({ page: 0, size: 200 });
 if (res.status === 200 && res.data) {
 setAllSymbols(res.data.content || []);
 }
 };

 const handleChange = (e) => {
 const { name, value } = e.target;
 setForm({ ...form, [name]: name === "sortOrder" ? Number(value) : value });
 };

 const toggleSymbol = (id) => {
 setForm((prev) => ({
 ...prev,
 symbolIds: prev.symbolIds.includes(id)
 ? prev.symbolIds.filter((x) => x !== id)
 : [...prev.symbolIds, id],
 }));
 };

 const handleSubmit = async () => {
 if (!form.title || !form.difficulty) {
 alert("Title and Difficulty are required");
 return;
 }

 setLoading(true);
 const res = isEdit
 ? await updateIpaLesson(lesson.id, form)
 : await createIpaLesson(form);

 if (res.status === 200 || res.status === 201) {
 onSaved();
 } else {
 alert(res.message || "Operation failed");
 }
 setLoading(false);
 };

 return (
 <div className="modal-overlay">
 <div className="modal-content">
 <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
 <div className="form-header">
 <h2>{isEdit ? "Edit IPA Lesson" : "Create IPA Lesson"}</h2>
 </div>

 <div className="form-grid">
 <div className="form-group">
 <label>Title *</label>
 <input name="title" placeholder="e.g. Short Vowels" value={form.title} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Difficulty *</label>
 <select name="difficulty" value={form.difficulty} onChange={handleChange}>
 <option value="">Select Difficulty</option>
 {difficultyOptions.map((opt) => (
 <option key={opt} value={opt}>{opt}</option>
 ))}
 </select>
 </div>

 <div className="form-group">
 <label>Sort Order</label>
 <input name="sortOrder" type="number" value={form.sortOrder} onChange={handleChange} />
 </div>

 <div className="form-group full-width">
 <label>Description</label>
 <textarea name="description" placeholder="Lesson description..." value={form.description} onChange={handleChange} rows={3} />
 </div>

 <div className="form-group full-width">
 <label>Symbols ({form.symbolIds.length} selected)</label>
 <div style={{ maxHeight: 200, overflow: "auto", border: "1px solid #ddd", borderRadius: 8, padding: 8 }}>
 {allSymbols.length === 0 ? (
 <p style={{ color: "#888" }}>No symbols available. Create symbols first.</p>
 ) : (
 allSymbols.map((s) => (
 <label key={s.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "4px 0", cursor: "pointer" }}>
 <input
 type="checkbox"
 checked={form.symbolIds.includes(s.id)}
 onChange={() => toggleSymbol(s.id)}
 />
 <span style={{ fontSize: "1.2rem" }}>{s.symbol}</span>
 <span style={{ color: "#666", fontSize: 13 }}>{s.name} ({s.type})</span>
 </label>
 ))
 )}
 </div>
 </div>
 </div>

 <div className="form-actions">
 <button className="btn primary" onClick={handleSubmit} disabled={loading}>
 {loading ? "Saving..." : isEdit ? "Update" : "Create"}
 </button>
 <button className="btn secondary" onClick={onCancel} disabled={loading}>
 Cancel
 </button>
 </div>
 </div>
 </div>
 </div>
 );
};

export default AdminIpaLessonForm;
